import React, { useState } from "react";
import { Chip } from "@mui/material";
import ContentCopy from "@mui/icons-material/ContentCopy";
import { useTranslation } from "@refinedev/core";

interface CopyableChipProps {
  initialLabel: string;
}

export const CopiableChip: React.FC<CopyableChipProps> = ({ initialLabel }) => {
  const [label, setLabel] = useState<string>(initialLabel);
  const [isCopied, setIsCopied] = useState<boolean>(false);
  const { translate } = useTranslation();

  const handleCopy = () => {
    if (initialLabel) {
      navigator.clipboard
        .writeText(initialLabel)
        .then(() => {
          setLabel(translate("common.copied"));
          setIsCopied(true);
          setTimeout(() => {
            setLabel(initialLabel);
            setIsCopied(false);
          }, 3000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    }
  };

  return (
    <Chip
      variant="filled"
      color="primary"
      size="small"
      sx={{ paddingLeft: 0.5 }}
      icon={<ContentCopy fontSize="small" />}
      label={
        <span className={`chip-label ${isCopied ? "copied" : ""}`}>
          {label}
        </span>
      }
      onClick={handleCopy}
    />
  );
};
